import React, { Component } from "react";
import axios from 'axios';
import TotalVotesContainer from "./total.style";

class TotalVotes extends Component {
  state = {
    total: 0
  };

  async componentDidMount() {
    const getVotes = await axios.post('/.netlify/functions/votes', { name: this.props.topic, subtopic: true });
    this.setState({
      total: getVotes.data.votes,
      title: this.props.topic
    });
  }

  render() {
    // const { topic } = this.props;
    const { total, title } = this.state;

    return (
      <TotalVotesContainer>
        <span className="num">{total} votes</span>
      </TotalVotesContainer >
    );
  }
}

export default TotalVotes;